import { render } from "./MedicalAppointments.vue?vue&type=template&id=3f77c354&scoped=true"
import script from "./MedicalAppointments.vue?vue&type=script&lang=js"
export * from "./MedicalAppointments.vue?vue&type=script&lang=js"

import "./MedicalAppointments.vue?vue&type=style&index=0&id=3f77c354&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f77c354"]])

export default __exports__